import React from "react";

interface IFavoriteTrackingEventsContext {
  recordHeartClickedEvent?: () => void;
  recordSaveToBoardSubmitEvent?: (boardToken?: string) => void;
  recordRemoveFromBoardSubmitEvent?: (boardToken?: string) => void;
}

export const FavoriteTrackingEventsContext =
  React.createContext<IFavoriteTrackingEventsContext>({});
